module.exports = __webpack_public_path__ + "static/img/19.4a21074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/19.jpg
// module id = T5eb
// module chunks = 0